import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

class TemplateEPLCopyAlert extends React.Component {

    static propTypes = {
      onOK: PropTypes.func,
      isOpen: PropTypes.bool,
      requestTypeName: PropTypes.string,
      projectName: PropTypes.string
    }

    render() {
      return (
        <Modal dialogClassName='confirm-cancel-save-eoc-template-dialog' show={this.props.isOpen} size='sm'>
          <Modal.Header>
            <Modal.Title style={{fontWeight: 'bold'}}>Error</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              There exists a template for the request type <b>{this.props.requestTypeName}</b> in the project <b>{this.props.projectName}</b>.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div style={{float: 'left'}}>
              <button className='btn btn-primary btn-siteone' onClick={this.props.onOK}>OK</button>
            </div>
          </Modal.Footer>
        </Modal>
      );
    }
}

export default TemplateEPLCopyAlert;



// WEBPACK FOOTER //
// ./src/Projects/Components/Template/template-epl-copy-alert.js